export const ACCEPT_TERMS_SUCCESS_TERMS_ACCEPTED = 'europa.user.data.AcceptTerms.TermsAccepted';
export const ACCEPT_TERMS_FAILURE_UNEXPECTED_FAILURE =
    'europa.user.data.AcceptTerms.UnexpectedFailure';
export const GET_ACCEPT_TERMS_SUCCESS_TERMS_ACCEPTED =
    'europa.user.data.GetAcceptTerms.TermsAccepted';
export const GET_ACCEPT_TERMS_FAILURE_UNEXPECTED_FAILURE =
    'europa.user.data.GetAcceptTerms.UnexpectedFailure';
export const GET_FTE_DATA_SUCCESS_FTE_DATA = 'europa.user.data.GetFteData.FteData';
export const GET_FTE_DATA_FAILURE_UNEXPECTED_FAILURE =
    'europa.user.data.GetFteData.UnexpectedFailure';
export const GET_FTE_DATA_FAILURE_USER_RELATED_DATA_NOT_FOUND =
    'europa.user.data.GetFteData.UserRelatedDataNotFound';
export const SET_FTE_DATA_SUCCESS_FTE_DATA_SET = 'europa.user.data.SetFteData.FteDataSet';
export const SET_FTE_DATA_FAILURE_UNEXPECTED_FAILURE =
    'europa.user.data.SetFteData.UnexpectedFailure';
export const SET_FTE_DATA_FAILURE_USER_RELATED_DATA_NOT_FOUND =
    'europa.user.data.SetFteData.UserRelatedDataNotFound';
